export default __webpack_public_path__ + "static/media/basic-pin-large-13.fcd61555.png";